
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.333 13.25h6.333v-1.583H3.333v1.583zm0-3.167h6.333V8.5H3.333v1.583zM1.75 16.417c-.436 0-.808-.155-1.118-.466a1.525 1.525 0 01-.465-1.118V2.167c0-.436.155-.809.465-1.119.31-.31.682-.465 1.118-.465h6.333l4.75 4.75v9.5c0 .436-.155.808-.465 1.118-.31.31-.683.466-1.118.466h-9.5zM7.292 6.125h3.958L7.292 2.167v3.958z"}})])
          )
        }
      }
    